import { useMemo } from 'react';

import { ActionCreatorsMapObject, bindActionCreators } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

export const useActions = <T extends ActionCreatorsMapObject>(actions: T): T => {
    const dispatch = useDispatch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const boundActions = useMemo(() => bindActionCreators(actions, dispatch), [dispatch, ...Object.values(actions)]);

    return boundActions;
};
